import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Group } from '@shared/models/group';
import { environment } from '@environments/environment';
import { UserType } from '@shared/types/user-type';
import { groupTypes } from '@shared/constants/group-types';
import { Contact } from '@shared/models/contact';

@Component({
  selector: 'app-group-item',
  templateUrl: './group-item.component.html',
  styleUrls: ['./group-item.component.scss'],
  standalone: false,
})
export class GroupItemComponent implements OnInit, OnChanges {
  @Input() group: Group;
  @Input() userType: UserType;
  @Output() selectedGroup = new EventEmitter<Group>();
  eset_group_id = environment.root_group_id;
  groupType: string | undefined;
  primary_contact: Contact | undefined;

  ngOnInit(): void {
    this.groupType = groupTypes.find((groupType) => groupType.reference === this.group.attributes.group_type)?.title;
    this.primary_contact = this.group!.attributes?.contacts?.find((contact) =>
      contact.contact_roles?.some((role) => role === 'primary'),
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['group']) {
      this.groupType = groupTypes.find((groupType) => groupType.reference === this.group.attributes.group_type)?.title;
      this.primary_contact = this.group?.attributes?.contacts?.find((contact) =>
        contact.contact_roles?.some((role) => role === 'primary'),
      );
    }
  }

  selectGroup() {
    this.selectedGroup.emit(this.group);
  }
}
